import {Card, CardContent, CardHead} from "../atoms/Card";
import {VerifyEmailForm} from "../molecules/VerifyEmailForm";
import {CheckIcon, ExclamationIcon} from "@heroicons/react/outline";
import {Button, Text} from "@chakra-ui/react";
import React from "react";

export type EmailVerificationCardProps = {
  emailIsVerified: boolean | null
  verifiedEmail: string | null | undefined
  userEmail: string | null
  formActive: boolean
  onConnect: (email: string) => Promise<any>
  onDisconnect: () => Promise<any>
}

export const EmailVerificationCard = ({
  verifiedEmail,
  emailIsVerified,
  formActive,
  userEmail,
  onConnect,
  onDisconnect
}: EmailVerificationCardProps) => {
  return <Card>
    <CardHead justify>
      {emailIsVerified ?
        <span className={"align-bottom"}><CheckIcon
          className={"h-6 w-6 inline text-green-700 mr-1"}/>Email verified</span> :
        <span className={"align-bottom"}><ExclamationIcon className={"h-6 w-6 inline text-orange-500 mr-1"}/>Add sender email</span>
      }

      {verifiedEmail &&
        <Button variant={"outline"}
          colorScheme={"gray"}
          size={"sm"}
          onClick={() => {
            if (onDisconnect) {
              onDisconnect()
            }
          }}><span>Remove email</span></Button>}
    </CardHead>
    <CardContent>
      <Text textColor={"pink.500"} fontSize={"sm"}>Premium feature</Text>
      <div>
        {!emailIsVerified && verifiedEmail && <p>Verification in progress...</p>}
        {!verifiedEmail && <div>
          <p>You can enter your email address to send emails on your behalf.</p>
          <p>If you add your email, it will appear as the sender when you send emails from Notion.</p>

          <p>Currently sending on behalf of <span className={"text-black"}>pages@notionsender.com</span></p>
          <VerifyEmailForm startValue={userEmail} onSubmit={(email) => onConnect(email)} formActive={formActive}/>
        </div>}

        {verifiedEmail && <div>Sending on behalf of <span className={"text-black"}>{verifiedEmail}</span> is available</div>}

      </div>
    </CardContent>

  </Card>
}
